import { MessageBar } from '@fluentui/react-components'
import { ErrorModal } from '../ErrorModal'
import { useEffect, useState } from 'react'
import { useInteractionContext } from '../../../../context/InteractionContext'

// used on if error is partial or when caused by a user action
export const ErrorBar = () => {
  const [displayMessageBar, setDisplayMessageBar] = useState<boolean>(true)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const { errors } = useInteractionContext()

  useEffect(() => {
    if (errors?.length > 0) {
      setDisplayMessageBar(true)
    } else {
      setDisplayMessageBar(false)
    }
  }, [errors?.length])

  const notificationAction = () => (
    <button onClick={() => setIsModalOpen(true)}>Visa mer detaljer</button>
  )

  if (displayMessageBar) {
    return (
      <>
        <MessageBar layout="multiline" intent="error">
          Något gick fel
          {notificationAction()}
        </MessageBar>

        <ErrorModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      </>
    )
  }

  return <></>
}
